const getProviderList = (employees) => {
    if (employees) {
        let providers = [];
        employees.map(employee => {
            if (employee.roles.provider && employee.services) {
                providers.push(employee);
            };
        });
        return providers;
    } else {
        throw new Error('Must provide employees but instead received:', employees);
        return null;
    }
};

export default getProviderList;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/utils/getProviderList.js